'use client'

import { useMainLayoutStore } from '@/stores/layout'
import { useEffect } from 'react'

type MainLayoutFeatureProps = {
  isShowFooter: boolean
}

const MainLayoutFeature = ({ isShowFooter }: MainLayoutFeatureProps) => {
  const { showFooter, hideFooter } = useMainLayoutStore()

  useEffect(() => {
    if (isShowFooter) showFooter()
    else hideFooter()
  }, [])
  return null
}

export default MainLayoutFeature
